<template>
    <div class="loginPage">
        <div class="login">
            <div class="loginPic">
                <img src="../assets/img/topLogo.jpg" alt="">
            </div>
            <el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="150px">
                <el-form-item prop="username" label="管理用户名：">
                    <el-input v-model="loginForm.loginname"></el-input>
                </el-form-item>
                <el-form-item prop="userpwd" label="管理用密码：">
                    <el-input type="password" v-model="loginForm.password"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="enter('loginForm')">进入管理页面</el-button>
            <el-button type="info" @click="back">返回首页</el-button>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
    import { login } from '../api/api.js'
    export default {
        name: 'backstage',
        created() {
            // console()
        },
        data() {
            return {

                loginForm: {
                    loginname: '',
                    password: ''
                },
                rules: {
                    loginname: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入用户密码', trigger: 'blur' }
                    ]
                },

            }
        },
        methods: {
            enter(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 发送登录请求
                        login(this.loginForm).then((res) => {
                            if (res.status === 1) {
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '登录成功',
                                    type: 'success'
                                });
                                sessionStorage.setItem('token', res.data.token)
                                this.$router.push('/htHome');
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {

                        return false;
                    }
                })
            },
            back() {
                this.$router.push('/homePage')
            }
        }
    }
</script>

<style scoped>
    .loginPage {
        width: 100%;
        height: 100%;
    }

    .login {
        text-align: center;
        /*让div内部文字居中*/
        background-color: #f5f5f5;
        border-radius: 20px;
        width: 30%;
        height: 20%;
        padding: 2% 6% 8% 6%;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .loginPic {
        margin-bottom: 6%;
    }
</style>



// WEBPACK FOOTER //
// src/components/backstage.vue